import { useEffect } from "react";
import { useSnackbar } from "notistack";
import { useOnline } from "utils/hooks";
import i18n from "./i18n";

// offline notification
const OfflineNotify = () => {
    // snackbar
    const { closeSnackbar, enqueueSnackbar } = useSnackbar();

    // online state change hook
    const isOnline = useOnline();
    useEffect(() => {
        if (!isOnline) {
            enqueueSnackbar(i18n.youAreOffline, {
                key: "offlineNotify",
                persist: true,
                variant: "error",
            });
        } else {
            closeSnackbar("offlineNotify");
        }
    }, [isOnline]); // eslint-disable-line

    return null;
};

export default OfflineNotify;
